import React, { useEffect, useState } from "react"
import { IbanElement } from "@stripe/react-stripe-js"
import { defineMessages, FormattedMessage } from "react-intl"
import FormRow from "../../form/row.component"
import Icon from "../../icon/icon.component"
import LoadingSpinner from "../../spinner/loading.component"

// Custom styling can be passed as options when creating an Element.
const IBAN_STYLE = {
    base: {
        color: "#32325d",
        fontSize: "16px",
        "::placeholder": {
            color: "#aab7c4"
        },
        ":-webkit-autofill": {
            color: "#32325d",
        },
    },
    invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
        ":-webkit-autofill": {
            color: "#fa755a",
        },
    }
}

const IBAN_ELEMENT_OPTIONS = {
    supportedCountries: ["SEPA"],
    // Elements can use a placeholder as an example IBAN that reflects
    // the IBAN format of your customer's country. If you know your
    // customer's country, we recommend that you pass it to the Element as the
    // placeholderCountry.
    style: IBAN_STYLE,
}


const messages = defineMessages({
    iban_name_label: {
        id: "common.sepa.stipe_iban_form.name_label",
        defaultMessage: "Name"
    },
    iban_email_label: {
        id: "common.sepa.stipe_iban_form.email_label",
        defaultMessage: "Email address"
    },
    iban_label: {
        id: "common.sepa.stipe_iban_form.iban_label",
        defaultMessage: "IBAN"
    },
    iban_submit_button_label: {
        id: "common.sepa.stipe_iban_form.submit_label",
        defaultMessage: "Set up SEPA Direct Debit"
    },
    iban_mandated_acceptance: {
        id: "common.sepa.stipe_iban_form.mandated_acceptance_prompt_label",
        defaultMessage: "By providing your payment information and confirming this payment, " +
            "you authorise (A) QuoteMachine and Stripe, our payment serviceprovider, to " +
            "send instructions to your bank to debit your account and (B) your bank to " +
            "debit your account in accordance with those instructions. As part " +
            "of your rights, you are entitled to a refund from your bank under the terms and " +
            "conditions of your agreement with your bank. A refund must be claimed within 8 weeks " +
            "starting from the date on which your account was debited. Your rights are explained in " +
            "a statement that you can obtain from your bank. You agree to receive notifications for " +
            "future debits up to 2 days before they occur."
    }
})

const TestIBANNumber = {
    "DE": "DE89370400440532013000"
}

type OwnProps = {
  onSubmit: (result) => void,
  error?: string,
  disabled: boolean,
  testMode: boolean,
  loading: boolean,
}

const StripeIbanForm = (props: OwnProps) => {
    const [testMode] = useState<boolean>(props.testMode || false)
    const [stripeError, setStripeError] = useState<string>(props.error || "")
    const [loading, setLoading] = useState<boolean>(props.loading || false)

    useEffect(() => {
        setStripeError(props.error ? props.error : "")
        setLoading(props.loading)
    }, [props.error, props.loading])

    return (
        <form name="iban_form" onSubmit={(res) => { props.onSubmit(res); setLoading(true) }}>
            <FormRow
                className={"mb-0 col-12 mx-auto"}
                style={"rows"}
                name={"accountholder-name"}
                label={<FormattedMessage{...messages.iban_name_label} />}
                input={<input required id={"accountholder-name"} type={"text"} className="form-control" />}
            />
            <FormRow
                className={"mb-0 col-12 mx-auto"}
                style={"rows"}
                name={"email"}
                label={<FormattedMessage{...messages.iban_email_label} />}
                input={<input required id={"email"} type={"email"} className="form-control" />}
            />
            <FormRow
                className={"mb-0 col-12 mx-auto"}
                style={"rows"}
                name={"iban-element"}
                label={<FormattedMessage{...messages.iban_label} />}
                input={<div className="border rounded p-2" >
                    <IbanElement options={IBAN_ELEMENT_OPTIONS} /></div>}
            />

            {testMode ? <div>
                <div className={"col-12 mx-auto"}>
                    <p className={"text-danger mb-0"}>
                        <small>
                            <Icon value={"info-circle"} className={"mr-1"} />
                            <FormattedMessage
                                id="common.iban.stipe_iban_form.test_account"
                                defaultMessage="You can use the following test IBAN number:"
                            />
                            <br />
                            <strong className={"pl-4"}>
                                {TestIBANNumber["DE"]}
                            </strong>
                        </small>
                    </p>
                </div>
            </div> : ""}

            {stripeError &&
        <div className="alert alert-danger mt-3 justify-content-center d-flex" role="alert">
            {stripeError}
        </div>
            }

            <div className={"row col-12 mt-2 mx-auto"}>
                <div className={"col-12 col-md-3 d-flex align-items-center justify-content-start mb-2"}>
                    <a href={"https://stripe.com"} target={"_blank"} className={"mr-1"} rel="noreferrer">
                        <img src={"/images/powered_by_stripe.png"} width={"80px"} />
                    </a>
                </div>
                <div className={"col-12 col-md-9 mt-2 d-flex justify-content-end"}>
                    {!loading ?
                        <button className='btn btn-primary w-100' type="submit" disabled={loading}>
                            <FormattedMessage{...messages.iban_submit_button_label} />
                        </button> :
                        <LoadingSpinner />}
                </div>
            </div>


            {/* remove mandated acceptance for now
      <div className="mandate-acceptance text-muted small mt-2">
        <FormattedMessage{...messages.iban_mandated_acceptance} />
      </div> */}
        </form>
    )
}

export default StripeIbanForm


// WEBPACK FOOTER //
// ./src/common/sepa/stripe/StripeIbanForm.tsx